import { render, staticRenderFns } from "./ColumnItemList.vue?vue&type=template&id=5a58887e&scoped=true"
import script from "./ColumnItemList.vue?vue&type=script&lang=js"
export * from "./ColumnItemList.vue?vue&type=script&lang=js"
import style0 from "./ColumnItemList.vue?vue&type=style&index=0&id=5a58887e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a58887e",
  null
  
)

export default component.exports